export enum KeyCodes {
    ENTER = 13,
    ESC = 27,
    UP = 38,
    DOWN = 40,
    TAB = 9,
    SPACE = 32,
    BACKSPACE = 8,
    SHIFT = 16,
    CTRL = 17,
    ALT = 18,
}